import { useApiQuery } from '../useApiQuery';
import { taskKeys } from '@/lib/queryKeys';
import { taskEndpoints } from '@/lib/api/endpoints';
import { apiGet, operationsClient } from '@/lib/api';
import { useCompanyTimezone } from '@/hooks/settings/useCompanyTimezone';
import { dateKeyInTimeZone } from '@/lib/date-values';
import type { Task, TaskListResponse } from '@/types/task';

export function useTodayTasks() {
  const companyTimezone = useCompanyTimezone();
  const today = companyTimezone ? dateKeyInTimeZone(new Date().toISOString(), companyTimezone) : '';

  return useApiQuery<TaskListResponse>({
    queryKey: taskKeys.list({ today: true, limit: 10 }),
    queryFn: async () => {
      const res = await apiGet<{ data: Task[]; total: number; page: number; limit: number }>(
        operationsClient,
        taskEndpoints.list(),
        { params: { dueDateFrom: today, dueDateTo: today, limit: 10 } },
      );
      return { tasks: res.data, total: res.total, page: res.page, limit: res.limit };
    },
    select: (data) => ({
      ...data,
      tasks: data.tasks.filter((t) => t.status !== 'done'),
    }),
    enabled: Boolean(today),
    showErrorToast: false,
  });
}
